import { Vue, Component, Prop } from 'vue-property-decorator';

import { LabelSetting } from '../../../i18n/locale-helper';

@Component({
    name: 'DataChangeConfirmModal',
    template: require('./template.html')
})
export default class DataChangeConfirmModal extends Vue {
    // Optional overrides for hosts where plain Yes/No is ambiguous (e.g. the embedded email editor).
    @Prop({ default: null }) discardLabel: string;
    @Prop({ default: null }) saveLabel: string;
    @Prop({ default: true }) showCancel: boolean;

    get lblGlobal() { return LabelSetting.Global; }
    get lblAction() { return LabelSetting.Action; }

    get discardText() { return this.discardLabel || this.$t(this.lblAction.no); }
    get saveText() { return this.saveLabel || this.$t(this.lblAction.yes); }

    confirmResult(action: string) {
        this.$emit(action);
    }
}